module.exports = __webpack_public_path__ + "media/images/icons/outlined/scissor-b4824f1c3cbadca5321406e1294dd72c.svg";